export const UnauthorizedAction = 'API::API_RESULT::UNAUTHORIZED'

export const unauthorized = error => ({
  type: UnauthorizedAction,
  error,
})
